import { render, staticRenderFns } from "./AssignTicket.vue?vue&type=template&id=a3c47734&scoped=true"
import script from "./AssignTicket.vue?vue&type=script&lang=js"
export * from "./AssignTicket.vue?vue&type=script&lang=js"
import style0 from "./AssignTicket.vue?vue&type=style&index=0&id=a3c47734&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c47734",
  null
  
)

export default component.exports